exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main[data-v-5796873c]{width:50vw}", ""]);

// exports
